import PortalDashboard from "@/portal/PortalDashboard";

export default function PortalLayout() {
  return <PortalDashboard />;
}
